import { createSlice } from '@reduxjs/toolkit';

const organizerSlice = createSlice({
    name: 'organizer',
    initialState: {
        organizerFiles: [],
        organizerProgress: 0,
        organizerIsProcessing: false,
        cancelRequested: false,
        autoAnalyze: false,
    },
    reducers: {
        setOrganizerFiles: (state, action) => {
            state.organizerFiles = action.payload;
        },
        setOrganizerProgress: (state, action) => {
            state.organizerProgress = action.payload;
        },
        setOrganizerIsProcessing: (state, action) => {
            state.organizerIsProcessing = action.payload;
        },
        resetOrganizerFilePath: (state) => {
            state.organizerFiles = [];
        },
        setOrganizerCancelRequested: (state, action) => {
            state.cancelRequested = action.payload;
        },
        setOrganizerAutoAnalyze: (state, action) => {
            state.autoAnalyze = action.payload;
        },
    },
});

export const {
    setOrganizerFiles,
    setOrganizerProgress,
    setOrganizerIsProcessing,
    resetOrganizerFilePath,
    setOrganizerCancelRequested,
    setOrganizerAutoAnalyze,
} = organizerSlice.actions;

export default organizerSlice.reducer;
